<template>
  <el-row class="flex-row page-user">
    <CompSideTree 
      pageName="userManage"
      :showBottomAdd="true"
      :showOrgFilter="false"
      :includeSubNodes="false"
      :bottomAddText="Lang.Button.userOrgAddOrg"
      @view="handleOrgDetail"
      @add="handleAddOrg"
      @edit="handleOrgEdit"
      @delete="handleOrgDelete"
      :permissionObj="permissionObj"
      @update:treeOption="(val) => (treeOption = val)"
      :treeData="treeData"
      :treeOption="treeOption"
      ref="treeRef"
      @nodeClick="nodeClick"
      @bottomAdd="handleAddOrganization"
      @updateSideTree="updateSideTree"
      ></CompSideTree>
    <el-col class="flex-col limitmain">
      <breadcrumb :repeat="true" v-if="website.setting.breadcrumb" />
      <div class="global-filter-condition-row">
        <div class="org-row">
          <div class="orgname-bar">
            <div class="orgname">
              <comp-svg name="tree-node"></comp-svg>
              <span class="text">{{ orgName }}</span>
            </div>
            <el-dropdown>
              <div class="type-select">
                <comp-button type="info" appendIcon="icon-do" :appendStyle="{
                  width: '14px',
                  height: '14px',
                  padding: '2px'
                  }"><span v-html="includeNodeName"></span></comp-button>
              </div>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item @click.stop="handleSelectChange(item)"  v-for="(item, i) in [
                    {label: Lang.Text.userOrgIncludeSub, value: '1'},
                    {label: Lang.Text.userOrgExcludeSub, value: '2'},
                  ]">
                    <span v-html="item.label"></span></el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </div>
      </div>
        <div class="global-content-section">
          <div class="page-search" style="padding: 20px 20px 16px;">
            <CompSearch :placeholder="Lang.Text.userOrgSearchName" v-model="search.nameOrIds" @change="handleSearch"></CompSearch>
            <div class="menu-right">
              <comp-button
                v-if="permissionObj.add"
                type="primary"
                icon="icon-add"
                @click="handleAddUser"
                style="margin-right: 8px;"
                >{{ Lang.Button.userOrgAddUser }}
              </comp-button>
              <comp-button
                v-if="permissionObj.editOrg"
                type="info"
                icon=""
                @click="handleChangeOrg()"
                style="margin-right: 8px;"
                >{{ Lang.Button.userOrgChangeOrg }}
              </comp-button>
              <comp-button
                type="info"
                icon=""
                v-if="permissionObj.resetPassword"
                @click="handleResetPassword()"
                >{{ Lang.Button.userOrgResetPass }}
              </comp-button>
            </div>
          </div>
          <div class="card-padding hide_avue_crud_header">
            <avue-crud
              class="global-table"
              :option="option"
              v-model:search="search"
              :table-loading="loading"
              :data="data"
              ref="crud"
              v-model="form"
              :permission="permissionObj"
              @row-del="rowDel"
              @row-update="rowUpdate"
              @row-save="rowSave"
              :before-open="beforeOpen"
              v-model:page="page"
              @search-change="searchChange"
              @search-reset="searchReset"
              @selection-change="selectionChange"
              @current-change="currentChange"
              @size-change="sizeChange"
              @refresh-change="refreshChange"
              @on-load="onLoad"
            >
              <template #tenantName="{ row }">
                <span>{{ row.tenantName }}</span>
              </template>
              <template #roleName="{ row }">
                <span>{{ row.roleName }}</span>
              </template>
              <template #deptName="{ row }">
                <span>{{ row.deptName }}</span>
              </template>
              <template #userTypeName="{ row }">
                <span>{{ row.userTypeName }}</span>
              </template>
              <template #menu="{row}">
                <div class="operation-btns">
                  <CompIconButton :auth="permissionObj" :authorize="true" :text="Lang.Title.userOrgUserDetail" icon="view" @click="handleViewUser(row)" > </CompIconButton>
                  <CompIconButton :auth="permissionObj" type="edit" v-if="row.status !== 0" @click="handleEditUser(row)" > </CompIconButton>
                  <CompIconButton :auth="permissionObj" type="editOrg" icon="changeOrg" v-if="row.status == 1 && row.account != 'admin'" :text="Lang.Button.userOrgChangeOrg" @click="handleChangeOrg(row)" > </CompIconButton>
                  <CompIconButton :auth="permissionObj" type="disable" :text="Lang.btn.disabled" v-if="row.status == 1 && row.account != 'admin'" @click="handleStatus(row, 0)" > </CompIconButton>
                  <CompIconButton :auth="permissionObj" type="disable" :text="Lang.btn.enable" icon="enable" v-if="row.status == 0 && row.account != 'admin'" @click="handleStatus(row, 1)" > </CompIconButton>
                  <CompIconButton :auth="permissionObj" type="resetPassword" v-if="row.status !== 0" @click="handleResetPassword(row)" > </CompIconButton>
                  <CompIconButton :auth="permissionObj" v-if="row.account != 'admin'" type="delete" :divider="false" @click="handleDelUser(row)" > </CompIconButton>
                </div>
              </template>
            </avue-crud>
          </div>
        </div>
    </el-col>


    <!-- 重置密码弹窗 -->
    <el-dialog title="" :show-close="false" :close-on-click-modal="false" style="border-radius: 12px; padding: 8px 24px 6px 24px;" append-to-body v-model="resetPasswordBox" width="450px">
      <el-form v-model="resetPasswordForm" label-position="top" @submit="handleResetPasswordSubmit">
        <el-form-item style="margin-bottom: 20px;">
          <comp-icon size="48px" name="warning"></comp-icon>
        </el-form-item>
        <el-form-item style="margin-bottom: 2px;">
          <div style="font-weight: 600; font-family: Roboto-Bold; font-size: 18px; line-height: 28px; color: #192434;">
            {{ Lang.btn.resetPassword }}
          </div>
        </el-form-item>
        <el-form-item v-if="selectionList.length > 1" style="margin-bottom: 14px;">
          <div style="font-family: Inter; line-height: 20px;">
            {{ getResetPasswordTips() }}
          </div>
          <div>
            <span style="margin: 0 4px;" v-for="(item, i) in selectionList">{{ item.account  || item.name}}</span>
          </div>
        </el-form-item>
        <el-form-item v-else>
          {{ Lang.Text.userOrgResetPassFor.replace('{邮箱}', resetPasswordForm.account || resetPasswordForm.name ) }}.
        </el-form-item>
        <el-form-item :label="Lang.Title.userOrgNewPass" prop="password">
          <el-input maxLength="20" :placeholder="Lang.tips.plzInputNewPassword" v-model="resetPasswordForm.password" type="password"></el-input>
        </el-form-item>
        <el-form-item >
          <div class="dialog-footer" style="text-align: center; width: 100%; margin-top: 12px;">
            <comp-button style="width: 48%;" @click="resetPasswordBox = false">{{ Lang.btn.cancel }}</comp-button>
            <comp-button style="width: 48%;" type="primary" @click="handleResetPasswordSubmit">{{ Lang.btn.confirm }}</comp-button>
          </div>
        </el-form-item >
      </el-form>
    </el-dialog>

    <!-- 移动组织弹窗 -->
    <el-dialog
      title=""
      lock-scroll
      append-to-body
      :close-on-click-modal="false"
      v-model="changeOrgBox"
      width="450px"
      style="border-radius: 12px; padding: 8px 24px 6px 24px;"
      height="600px">
      <el-form v-model="changeOrgForm" label-position="top">
        <el-form-item style="margin-bottom: 20px;">
          <comp-icon size="48px" name="warning"></comp-icon>
        </el-form-item>
        <el-form-item style="margin-bottom: 2px;">
          <div style="font-family: Roboto-Bold; font-size: 18px; line-height: 28px; color: #192434;">
            {{ Lang.Button.userOrgChangeOrg }}
          </div>
        </el-form-item>
        <el-form-item style="margin-bottom: 14px;">
          <div style="font-family: Inter; line-height: 20px; ">
            {{ getResetOrgTips() }}
          </div>
          <div v-if="selectionList.length">
            <span style="margin: 0 4px;" v-for="(item, i) in selectionList">{{ item.account }}</span>
          </div>
          <div v-else>
            <span style="margin: 0 4px;">{{ changeOrgForm.account }}</span>
          </div>

        </el-form-item>
        <el-form-item :label="Lang.Title.userOrgNewOrg" prop="organization">
          <el-tree-select
            v-model="changeOrgForm.organizationIds"
            :data="treeData"
            multiple
            :render-after-expand="false"
            show-checkbox
            check-strictly
            check-on-click-node
            node-key="id"
            :props="{
              children: 'children',
              label: 'title',
              value: 'value',
              key: 'id',
            }"
            @change="handleOrganizationChange"
            :placeholder="Lang.Text.basicTxPlsSelect.replace('{Title}', Lang.label.energyFlowOrg)"
          />
        </el-form-item>
        <el-form-item >
          <div class="dialog-footer" style="text-align: center; width: 100%; margin-top: 12px;">
            <comp-button size="large" style="width: 48%;" @click="changeOrgBox = false">{{ Lang.btn.cancel }}</comp-button>
            <comp-button size="large" style="width: 48%;" type="primary" @click="handleChangeOrgSubmit">{{ Lang.btn.confirm }}</comp-button>
          </div>
        </el-form-item >
      </el-form>
    </el-dialog>

    <!-- 新增编辑组织弹窗 -->
    <el-dialog
      :title="getOrgDialogTitle()"
      :close-on-click-modal="operationType=='view'"
      class="global-dialog"
      append-to-body
      v-model="orgDialog"
      :class="{
        'global-dialog-view': ['view'].includes(operationType),
      }"
      width="520px" >
      <avue-form
        v-if="orgDialog"
        :option="orgFormOption"
        ref="orgFormRef"
        class="dialog-custom-class-sort"
        v-model="orgForm"
        @submit="handleSubmitOrg">
        <template #region="{ row }">
          <el-cascader 
            :disabled="operationType=='view'"
            v-model="orgForm.region"
            :props="cascaderProps"
            :lazy="true"
            :show-all-levels="true"
            :lazy-load="loadRegionData"
            :placeholder="Lang.tips.plzSelectRegion"
            @change="handleRegionChange"
            clearable
            style="width: 100%;"
          />
        </template>
      </avue-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button v-if="operationType!='view' && permissionObj.editOrg" @click="orgDialog = false">{{ Lang.btn.cancel }}</el-button>
          <el-button v-if="operationType!='view' && permissionObj.editOrg" type="primary" @click="() => {this.$refs.orgFormRef.submit()}">{{ Lang.btn.confirm }}</el-button>
          <el-button v-if="operationType=='view' && permissionObj.editOrg" type="primary" @click="switchToEdit(1)">{{ Lang.btn.edit }}</el-button>
        </div>
      </template>
    </el-dialog>

    <!-- 新增编辑用户弹窗 -->
    <el-dialog
      :title="getDialogTitle()" 
      :close-on-click-modal="operationType=='view'"
      class="global-dialog"
      :class="{
          'global-dialog-view': ['view'].includes(operationType),
        }"
      append-to-body
      width="600px"
      v-model="userDialog" size="80%" >
      <avue-form
        :key="userFormOption.formKey"
        :option="userFormOption"
        ref="userFormRef"
        class="dialog-custom-class-sort"

        v-model="userForm"
        v-if="userDialog"
        @submit="handleSubmitUser">
        <template #avatar="{ row }">
          <CompUploadAvatar
            v-if="operationType=='view'"
            :disabled="operationType=='view'"
            @update:modelValue="handleAvatarUpdate"
            v-model="userForm.avatar"
            :showUserInfo="operationType=='view'"
            :userInfo="userForm"
          />
        </template>
        <template #phone="{ row }">
          <CompPhone 
            :disabled="operationType=='view'"
            v-model="userForm.phone" 
            @change="handlePhoneChange"
          />
        </template>
        <template #deptId="{ row }">
          <el-tree-select
            v-model="userForm.deptId"
            :disabled="operationType=='view'"
            :data="treeData"
            multiple
            :render-after-expand="false"
            show-checkbox
            check-strictly
            check-on-click-node
            node-key="id"
            :props="{
              children: 'children',
              label: 'title',
              value: 'value',
              key: 'id',
            }"
            @change="handleSelectDept"
            :placeholder="Lang.Text.basicTxPlsSelect.replace('{Title}', Lang.label.energyFlowOrg)"
          />
        </template>
      </avue-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button size="large" v-if="operationType!='view' && permissionObj.edit" @click="userDialog = false">{{ Lang.btn.cancel }}</el-button>
          <el-button size="large" v-if="operationType!='view' && permissionObj.edit" type="primary" @click="() => {this.$refs.userFormRef.submit()}">{{ Lang.btn.confirm }}</el-button>
          <el-button size="large" v-if="operationType=='view' && permissionObj.edit" type="primary" @click="switchToEdit(2)">{{ Lang.btn.edit }}</el-button>
        </div>
      </template>
    </el-dialog>

    
  </el-row>
</template>

<script>
import {
  getList,
  getUser,
  remove,
  update,
  add,
  grant,
  resetPassword,
  auditPass,
  auditRefuse,
  getDictionary,
  getCountryCodeList,
} from '@/api/system/user';
import {
  getDeptLazyTree,
  getDeptTree,
  update as updateOrg,
  add as addOrg,
  remove as deleteOrg,
  getDetail as getOrgDetail,
  moveUserDept,
} from '@/api/system/dept';
import { getRoleTree } from '@/api/system/role';
import { mapGetters } from 'vuex';
import website from '@/config/website';
import { getAllChildIds, findInTreeIterative, removeTreeNodeById } from '@/utils/util';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import func from '@/utils/func';
import sideTree from './comps/sideTree';
import { getLazyTree } from '@/api/base/region';
import { 
  validatePass, isValidLatitude, isValidLongitude,
  validatePasswordSimple, validateUerName,
  validateUserCode, validatePassword, validateEmail,
  validateOrgCode,
  validateInt,
} from '@/utils/validator';
import CompSideTree from '@/components/comp-side-tree/index.vue';
import CompSearch from '@/components/comp-search/index.vue';
import CompPhone from '@/components/comp-phone/index.vue';
import CompUploadAvatar from '@/components/comp-upload-avatar/index';




export default {
  components: {
    sideTree,
    CompSideTree,
    CompSearch,
    CompPhone,
    CompUploadAvatar,
  },
  data() {
    return {
      orgName: '',
      regionCode: '',
      includeNodeType: '1',
      includeNodeName: this.Lang.Text.userOrgIncludeSub,
      form: {},
      treeForm: {},
      orgForm: {
        region: [],
      },
      treeOption: {
        nodeKey: 'id',
        filter: false,
        // defaultExpandAll: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        props: {
          label: 'title',
          value: 'key',
          children: 'children',
        },
      },
      cascaderProps: {
        value: 'id',      // 使用 'id' 作为 value
        label: 'title',   // 数据里是 'title' 而不是 'label'
        children: 'children',
        lazy: true,
        leaf: 'isLeaf',   // 指定叶子节点判断字段
        lazyLoad: this.loadRegionData, // 懒加载方法
      },
      changeOrgForm: {
        organizationIds: '',
      },
      search: {},
      orgDialog: false,
      userDialog: false,
      changeOrgBox: false,

      resetPasswordForm: {},
      resetPasswordOption: {
        submitText: this.Lang.btn.confirm,
        emptyText: this.Lang.btn.cancel,
        column: [
          {
            label: this.Lang.Title.enterpriseEntpName,
            prop: 'name',
            span: 24,
            disabled: true,
          },
          {
            label: this.Lang.label.newPassword,
            prop: 'password',
            span: 24,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputNewPassword,
                trigger: 'blur',
              },
              { required: true, validator: validatePassword, trigger: 'blur' }
            ],
          },
        ],
      },
      resetPasswordBox: false,
      operationType: '',
      roleBox: false,
      excelBox: false,
      platformBox: false,
      initFlag: true,
      auditMode: false,
      selectOptions: [],
      selectionList: [],
      countryCodeList: [],
      defaultAreaCode: '',
      query: {},
      loading: true,
      platformLoading: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      platformPage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      init: {
        roleTree: [],
        deptTree: [],
      },
      props: {
        label: 'title',
        value: 'key',
      },
      roleGrantList: [],
      roleTreeObj: [],
      treeDeptId: '',
      treeData: [],
      userFormOption: {
        formKey: 0,
        labelPosition: 'top',
        gutter: 16,
        emptyBtn: false,
        submitBtn: false,
        labelSuffix: ' ',
        group: [
          {
            label: this.Lang.label.baseInfo,
            prop: 'baseInfo',
            icon: 'el-icon-user-solid',
            labelWidth: 120,
            column: [
            {
                label: '',
                span: 24,
                row: true,
                slot: true,
                prop: 'avatar',
                editDisplay: false,
                viewDisplay: true,
                hide: true,
              },
              {
                label: this.Lang.Title.userOrgAccount,
                prop: 'account',

                maxlength: 100,
                rules: [
                  {
                    required: true,
                    message: this.Lang.tips.inputLoginAccount,
                    trigger: 'blur',
                  },
                ],
              },
              {
                label: this.Lang.label.roleOf,
                prop: 'roleId',
                multiple: false,
                defaultExpandAll: true,
                type: 'tree',
                dicData: [],
                dataType: 'string',
                props: {
                  label: 'title',
                },
                // checkStrictly: true,
                slot: true,
                rules: [
                  {
                    required: true,
                    message: this.Lang.tips.plzSelectRole,
                    trigger: 'click',
                  },
                ],
              },
              {
                label: this.Lang.Title.userOrgAuthoOrg,
                prop: 'deptId',
                type: 'tree',
                multiple: true,
                checkStrictly: true,
                defaultExpandAll: true, // 回显关键
                nodeKey: 'id', // 回显关键
                // dataType: 'string',
                placeholder: this.Lang.tips.plzSelect + ' ' +  this.Lang.Title.userOrgAuthoOrg,
                props: {
                  label: 'title',
                  value: 'value',
                  children: 'children',
                },
                slot: true,
                rules: [
                  {
                    required: true,
                    message: this.Lang.tips.plzSelect + ' ' +  this.Lang.Title.userOrgAuthoOrg,
                    trigger: 'click',
                  },
                ],
              },
              {
                label: this.Lang.label.userName,
                prop: 'name',
                maxlength: 100,
                rules: [
                  {
                    required: true,
                    message: this.Lang.tips.inputUserName,
                    trigger: 'blur',
                  },
                ],
              },
              {
                label: this.Lang.label.password,
                prop: 'password',
                display: true,
                rules: [{ required: true, validator: validatePassword, trigger: 'blur' }],
              },
            ],
          },
          {
            label: this.Lang.label.detailInfo,
            prop: 'detailInfo',
            labelWidth: 140,
            column: [
              {
                label: this.Lang.label.phoneNumber,
                prop: 'phone',
                overHidden: true,
                slot: true,
                span: 12,
                prefixIcon: 'el-icon-mobile-phone',
                prepend: '+86',
              },
              {
                label: this.Lang.label.email,
                prop: 'email',
                hide: true,
                overHidden: true,
                rules: [
                  {
                    required: false,
                    trigger: 'blur',
                    validator: validateEmail,
                  },
                ],
              },
              {
                label: this.Lang.Title.userOrgUserCode,
                prop: 'code',
                maxlength: 30,
                hide: true,
                overHidden: true,
                rules: [
                  {
                    required: false,
                    trigger: 'blur',
                    validator: validateUserCode,
                  },
                ],
              },
              {
                label: this.Lang.label.userGender,
                prop: 'sex',
                type: 'tree',
                defaultExpandAll: true,
                multiple: false,
                dicUrl: '/blade-system/dict/dictionary-tree?code=sex',
                rules: [
                  {
                    required: true,
                    trigger: 'blur',
                    message: this.Lang.tips.plzSelect + ' ' + this.Lang.label.userGender,
                  },
                ],
                props: {
                  label: 'i18nValue',
                  value: 'dictKey',
                },
                hide: true,
              },
            ],
          },

        ]
      },
      userForm: {
        // phone: ''
        deptId: [],
      },
      option: {
        // height: 'auto',
        maxHeight: 600, // 因为设计要求分页不要固定在底部 height: 'auto'
        calcHeight: 86,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        gutter: 20,
        border: false,
        index: false,
        indexLabel: this.Lang.table.serialNumber,
        indexWidth: '100%',
        selection: true,
        menuWidth: 216, // 操作列宽
        addBtn: false, // 添加
        viewBtn: false, // 查看
        editBtn: false, // 编辑
        delBtn: false, // 删除
        menuType: 'button',
        menuTitle: this.Lang.label.operation,
        menuHeaderAlign: 'right', // 操作按钮样式
        dialogType: 'drawer',
        labelPosition: 'top',
        dialogClickModal: false,
        showOverflowTooltip: true,
        dialogCustomClass: 'dialog-custom-class-sort',
        column: [
          {
            label: this.Lang.Title.userOrgStatus,
            prop: 'statusDesc',
            search: false,
            display: false,
          },
          {
            label: this.Lang.Title.userOrgName,
            prop: 'name',
            search: false,
            display: false,
          },
          {
            label: this.Lang.Title.userOrgUserCode,
            prop: 'code',
            search: false,
            display: false,
          },
          {
            label: this.Lang.Title.userOrgSex,
            prop: 'sexName',
            search: false,
            display: false,
          },
          {
            label: this.Lang.Title.userOrgAccount,
            prop: 'account',
            search: false,
            display: false,
          },
          {
            label: this.Lang.Title.userOrgRole,
            prop: 'roleName',
            slot: true,
            type: 'tree',
            display: false,
          },
          
          {
            label: this.Lang.Title.userOrgOrgan,
            prop: 'deptName',
            search: false,
            display: false,
          },
          {
            label: this.Lang.Title.userOrgEmail,
            prop: 'email',
            search: false,
            display: false,
          },
          {
            label: this.Lang.Title.userOrgUpdateTime,
            prop: 'updateTime',
            search: false,
            display: false,
          },
          {
            label: this.Lang.Title.userOrgUpdateBy,
            prop: 'updateUserName',
            search: false,
            display: false,
          },
          {
            label: this.Lang.Title.userOrgPassword,
            prop: 'password',
            slot: true,
            display: false,
            hide: true,
          },

        ],
      },
      data: [],
      orgFormOption: {
        formKey: 0,
        labelPosition: 'top',
        gutter: 16,
        emptyBtn: false,
        submitBtn: false,
        labelSuffix: ' ',
        column: [
          {
            label: this.Lang.Title.userOrgOrgName,
            prop: 'deptName',
            search: true,
            span: 24,
            maxlength: 100,
            disabled: this.operationType === 'view',
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInput + ' ' + this.Lang.Title.userOrgOrgName,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.Title.userOrgOrgType,
            prop: 'deptCategory',
            span: 24,
            search: true,
            nodeKey: 'id',
            type: 'tree',
            dicUrl: '/blade-system/dict/dictionary-tree?code=org_category',
            addDisplay: false,
            editDisplay: false,
            props: {
              label: 'i18nValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzSelect + this.Lang.Title.userOrgOrgType,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.Title.userOrgParentOrg,
            prop: 'parentId',
            span: 24,
            // dicUrl: '/blade-system/dept/tree',
            dicData: [],
            type: 'tree',
            hide: false,
            addDisabled: false,
            props: {
              label: 'title',
            },
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzSelect + this.Lang.Title.userOrgParentOrg,
                trigger: 'click',
              },
            ],
          },
          {
            label: this.Lang.Title.userOrgSequence,
            prop: 'sort',
            maxlength: 5,
            span: 24,
            type: 'number',
            align: 'left',
            min: 0,
            rules: [
              {
                required: false,
                validator: validateInt,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.Title.userOrgOrgCode,
            prop: 'deptCode',
            placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.Title.userOrgOrgCode,
            span: 24,
            align: 'left',
            maxlength: 30,
            rules: [
              {
                required: false,
                message: this.Lang.tips.plzInput + this.Lang.Title.userOrgOrgCode,
                trigger: 'blur',
              },
              {
                required: false,
                validator: validateOrgCode,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.Title.userOrgRegion,
            span: 24,
            prop: 'region',
            type: 'tree',
            slot: true,
            lazy: true,
            dicUrl: '/blade-system/region/lazy-tree',
            collapseTags: true,
            leafOnly: false,
            virtualize: true,
            nodeKey: 'id', // 回显关键
            props: {
              label: 'title',
              value: 'codes',
            },
            rules: [
              {
                required: false,
                message: this.Lang.tips.plzSelectRegion,
                trigger: 'click',
              },
            ],
          },
          {
            label: this.Lang.Title.userOrgAddress,
            prop: 'address',
            placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.Title.userOrgAddress,
            span: 24,
            maxlength: 200,
            showWordLimit: true,
            type: 'textarea',
            rules: [
              {
                required: false,
                message: this.Lang.tips.plzInputRemark,
                trigger: 'blur',
              },
            ],
            hide: true,
          },
          {
            label: this.Lang.Title.userOrgLat,
            prop: 'latitude',
            span: 12,
            placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.Title.userOrgLat,
            rules: [{ required: false, validator: isValidLatitude, trigger: 'blur' }],
            hide: true,
          },
          {
            label: this.Lang.Title.userOrgLong,
            prop: 'longitude',
            span: 12,
            placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.Title.userOrgLong,
            rules: [{ required: false, validator: isValidLongitude, trigger: 'blur' }],
            hide: true,
          },
        ]
      },
      platformQuery: {},
      platformSelectionList: [],
      platformData: [],
      platformForm: {},
      excelForm: {},
    };
  },
  computed: {
    ...mapGetters(['menuItem', 'permission', 'userInfo', 'language']),
    permissionObj() {
      const keys = Object.keys(this.permission)
      const obj = {}
      const menuId = this.menuItem.id;
      keys.forEach((key => {
        if (key.indexOf(menuId) > -1) {
          const btnType = key.substr(menuId.length);
          obj[btnType] = true;
        }
      }))
      console.log('页面权限', obj)
      return obj
    },
    platformPermissionList() {
      return {
        addBtn: false,
        viewBtn: false,
        delBtn: false,
        editBtn: this.validData(this.permission.user_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  mounted() {
    // 非租户模式默认加载管理组数据
    this.initData();
    this.updateSideTree()
  },
  methods: {
    getResetPasswordTips() {
      return this.Lang.Text.userOrgNewPassFor.replace('{数字}', this.selectionList.length).replace('{邮箱}', '')
    },
    getResetOrgTips() {
      return this.Lang.Text.userOrgChangeOrgFor.replace('{数字}', this.selectionList.length).replace('{邮箱}', '')
    },
    loadRegionData(node, resolve) {
      const parentCode = node.level === 0 ? '00' : node.value;
      getLazyTree(parentCode).then((res) => {
        const data = res.data.data || [];
        resolve(data.map((item) => ({
          id: item.id,           // 确保和 cascaderProps.value 一致
          title: item.title,     // 确保和 cascaderProps.label 一致
          isLeaf: !item.hasChildren,
        })));
      });
    },
    handleRegionChange(value, selectedData) {
      // 处理地区变化
      console.log('地区变化:', value);
      this.orgForm.region = value;
    },
    // 自定义查看
    handleView(row) {
      this.$refs.crud.rowView(row);
    },
    // 自定义编辑
    handleEdit(row) {
      this.switchToEdit(2)
      this.$refs.crud.rowEdit(row);
    },
    // 自定义删除
    handleDel(row) {
      this.$refs.crud.rowDel(row);
    },
    nodeClickOld(data, Node, treeData) {
      this.orgName = data.title;
      this.treeData = treeData;
      this.treeDeptId = data.id;
      this.treeDeptIds = getAllChildIds(data).join(',');
      this.page.currentPage = 1;
      this.onLoad(this.page);
    },
    nodeClick({data, Node, treeData}) {
      this.orgName = data.title;
      // this.treeData = treeData;
      this.treeDeptId = data.id;
      this.treeDeptIds = getAllChildIds(data).join(',');
      this.page.currentPage = 1;
      this.onLoad(this.page);
    },
    getOrgDialogTitle() {
      if (this.operationType == 'add') {
        return this.Lang.Button.userOrgAddOrg;
      } else if (this.operationType == 'view') {
        return this.Lang.Title.orgDetail;
      } else {
        return this.Lang.Title.userOrgEditOrg
      }
    },
    getDialogTitle() {
      if (this.operationType == 'add') {
        return this.Lang.Button.userOrgAddUser;
      } else if (this.operationType == 'view') {
        return this.Lang.Title.userOrgUserDetail;
      } else {
        return this.Lang.Title.userOrgEditUser
      }
    },
    switchToEdit(flag) {
      this.operationType = 'edit';
      if (flag == 1) {
        this.disabledForm(this.orgFormOption, false);
      } else {
        this.disabledForm(this.userFormOption, false);
      }
    },
    // 查看时禁用编辑
    disabledForm(option, flag) {
      if (option.group) {
        option.group.forEach(section => {
          if (section.column && section.column.length) {
            section.column.forEach(col => {
              col.disabled = flag;
              if (col.prop == 'password') {
                if (this.operationType == 'add') {
                  col.display = true;
                } else {
                  col.display = false;
                }
              }
            })
          }
        })
      } else {
        if (option.column && option.column.length) {            
          option.column.forEach(col => {
            col.disabled = flag;
            if (col.prop == 'password') {
              if (this.operationType == 'add') {
                col.display = true;
              } else {
                col.display = false;
              }
            }
          });
        }
      }
      option.formKey++
    },
    handleAddUser() {
      this.operationType = 'add';
      this.userDialog = true;
      this.disabledForm(this.userFormOption, false)
      this.userFormOption.submitText = this.Lang.btn.confirm;
      this.userFormOption.emptyText = this.Lang.btn.cancel;
      this.userForm = {
        tenantId: this.userInfo.tenant_id,
        // deptId: this.treeDeptId,
        roleId: this.roleTreeObj.join(','),
      };
    },
    handleAvatarUpdate(val) {
      console.log(val)
    },
    handleViewUser(row) {
      this.operationType = 'view';
      this.userDialog = true;
      row.sex = row.sex + '';
      this.userForm = row;
      this.userForm.phone = row.phone;
      console.log(row)
      this.disabledForm(this.userFormOption, true)
      this.userForm.deptId = func.split(this.userForm.deptId);
      this.userForm.roleId = func.split(this.userForm.roleId);
      this.userForm.postId = func.split(this.userForm.postId);
    },
    handleEditUser(row) {
      this.operationType = 'edit';
      this.userDialog = true;
      this.disabledForm(this.userFormOption, false)
      this.userFormOption.group[0].column.forEach(item => {
        if (item.prop == 'account') {
          item.disabled = true;
        }
      })
      row.sex = row.sex + '';
      this.userForm = row;
      this.userForm.deptId = func.split(this.userForm.deptId);
      this.userForm.roleId = func.split(this.userForm.roleId);
      this.userForm.postId = func.split(this.userForm.postId);
    },
    handlePhoneChange(data) {
      this.userForm.phone = data.phoneNumber;
      this.userForm.areaCode = data.countryCode;
    },
    // 修改状态
    handleStatus(row, status) {
      row.deptId = func.join(row.deptId);
      row.roleId = func.join(row.roleId);
      row.postId = func.join(row.postId);
      const params = row;
      params.status = status;
      update(params).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        },
        error => {
          window.console.log(error);
        }
      );
    },
    handleDelUser(row) {
      this.$dialog({
        type: 'warning',
        icon: 'warning',
        title: this.Lang.Title.userOrgDeleteUser,
        content: `${this.Lang.label.loginAcc}: ${row.account || row.name} <br/>${this.Lang.tips.deleteCantBeRestored}`,
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        showClose: false,
      })
      // this.$confirm(this.Lang.tips.ifConfirmDelete, {
      //   confirmButtonText: this.Lang.btn.confirm,
      //   cancelButtonText: this.Lang.btn.cancel,
      //   type: 'warning',
      // })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
    },
    handleChangeOrg(r) {
      if (r) {
        this.$refs.crud.toggleRowSelection(r, true); // 设置某一行选中
      }
      if (!this.selectionList.length) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      const row = this.selectionList[0];
      this.changeOrgForm = {
        organizationIds: row.deptId,
        userId: row.id,
        name: row.name,
        account: row.account,
        tenantId: row.tenantId,
        password: '',
      };
      this.changeOrgBox = true;
    },
    handleSelectDept(deptId) {
      // this.userForm.deptId = deptId.join(',');
    },
    handleOrganizationChange(val) {
      // this.dimensionId = val;
      this.changeOrgForm.organizationIds = val;
      console.log(this.changeOrgForm.organizationIds, val)
    },
    // 移动组织提交
    handleChangeOrgSubmit() {
      if (!this.changeOrgForm.organizationIds.length) {
        this.$message.error(this.Lang.tips.plzSelect + this.Lang.Title.userOrgNewOrg);
        return;
      }
      moveUserDept({userIds: this.ids, deptIds: this.changeOrgForm.organizationIds.join(',')}).then((res) => {
        if (res.data.code === 200) {
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.changeOrgBox = false;
          this.onLoad(this.page, this.query);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 查看组织
    handleOrgDetail(node) {
      this.operationType = 'view';
      this.disabledForm(this.orgFormOption, true)
      const data = node.data;
      getOrgDetail(data.id).then(res => {
        const data = res.data.data;
        data.deptCategory = data.deptCategory + '';
        this.orgForm = {
          ...data,
          region: data.region.split(','),
          deptName: data.deptName,
        };
        this.orgDialog = true;
      });
    },
    handleSelectChange(item) {
      this.includeNodeType = item.value;
      this.includeNodeName = item.label;
      this.onLoad(this.page);
    },
    handleAddOrg() {
      this.operationType = 'add';
      this.disabledForm(this.orgFormOption, false)
      this.orgForm = {
        region: [],
        tenantId: this.userInfo.tenant_id,
      };
      this.orgDialog = true;
    },
    // 编辑组织
    handleOrgEdit(node) {
      this.operationType = 'edit';
      this.disabledForm(this.orgFormOption, false)
      const data = node.data;
      getOrgDetail(data.id).then(res => {
        const data = res.data.data;
        data.deptCategory = data.deptCategory + '';
        this.updateParentOrgDicdata(data.id)
        this.orgForm = {
          ...data,
          region: data.region.split(','),
          deptName: data.deptName,
        };
        this.orgDialog = true;
      });
    },
    // 检查该节点是否还有用户
    checkNodeUsers(page, params = {}) {
      const depIds = this.includeNodeType == '1' ? this.treeDeptIds : this.treeDeptId;
      return getList(
        page.currentPage,
        page.pageSize,
        Object.assign(params, this.query),
        depIds
      )
    },
    // 删除组织
    async handleOrgDelete(node) {
      const data = node.data;
      const level = node.level;
      if (data.hasChildren) {
        // 有子级
        return this.$dialog({
          title: this.Lang.Title.userOrgDeleteOrg,
          titleStyle: 'font-weight:600;margin:10px 0 6px 0;',
          icon: 'warning',
          iconSize: '50px',
          iconColor: '#FEF3F2',
          content: this.Lang.Text.userOrgSubOrgDel,
          confirmButtonText: this.Lang.btn.confirm,
          cancelButtonText: this.Lang.btn.cancel,
          cancelButtonType: 'default',
          confirmButtonType: 'primary',
          showClose: false,
          cancelButtonStyle: {
            width: '168px',
            height: '40px',
          },
          confirmButtonStyle: {
            width: '168px',
            height: '40px',
          }
        })
      }
      const treeDeptIds = getAllChildIds(data).join(',');
      const res = await this.checkNodeUsers(
        { currentPage: 1, pageSize: 1 }, 
        { tenantId: this.userInfo.tenant_id, deptId: treeDeptIds }
      )
      const records = res.data.data.records;
      console.log(records)
      if (records.length) {
        // 有用户
        return this.$dialog({
          title: this.Lang.Title.userOrgDeleteOrg,
          titleStyle: 'font-weight:600;margin:10px 0 6px 0;',
          icon: 'warning',
          iconSize: '50px',
          iconColor: '#FEF3F2',
          content: this.Lang.Text.userOrgAllUserDel,
          confirmButtonText: this.Lang.btn.confirm,
          cancelButtonText: this.Lang.btn.cancel,
          cancelButtonType: 'default',
          confirmButtonType: 'primary',
          showClose: false,
          cancelButtonStyle: {
            width: '168px',
            height: '40px',
          },
          confirmButtonStyle: {
            width: '168px',
            height: '40px',
          }
        })
      }
      // 删除组织红色弹框
      this.$dialog({
        title: this.Lang.Title.userOrgDeleteOrg,
        titleStyle: 'font-weight:600;margin:10px 0 6px 0;',
        icon: 'danger',
        iconSize: '50px',
        iconColor: '#FEF3F2',
        organizationTitle: this.Lang.Title.userOrgOrgan,
        organization: data.title,
        content: `<div style="color:red;margin:8px 0;">${this.Lang.Text.dimensionDelNodeCon}</div>`,
        confirmButtonText: this.Lang.btn.delete,
        cancelButtonText: this.Lang.btn.cancel,
        cancelButtonType: 'pink',
        confirmButtonType: 'danger',
        showClose: false,
        nodeLevel: `(${level})${this.Lang.Text.level}`,
        cancelButtonStyle: {
          width: '168px',
          height: '40px',
        },
        confirmButtonStyle: {
          width: '168px',
          height: '40px',
        }
      })
      .then(() => {
        return deleteOrg(data.id);
      })
      .then(() => {
        this.updateSideTree()
        this.onLoad(this.page);
        this.$message({
          type: 'success',
          message: this.Lang.tips.operationSuccess,
        });
        this.$refs.crud.toggleSelection();
      });
    },
    setParentDicData(data) {
      this.orgFormOption.column.forEach(item => {
        if (item.prop == 'parentId') {
          item.dicData = data
        }
      })
    },
    updateParentOrgDicdata(id) {
      // 当前节点的 ID
      const parentNodes = removeTreeNodeById(this.treeData, id)
      console.log(parentNodes)
      this.setParentDicData(parentNodes)
    },
    // 底部添加组织
    handleAddOrganization() {
      this.operationType = 'add';
      this.disabledForm(this.orgFormOption, false);
      this.setParentDicData(this.treeData);
      this.orgForm = {
        sort: 0,
      };
      this.orgDialog = true;
    },
    // 新增组织
    handleSubmitOrg(data, done) {
      const submitFunction = this.operationType === 'edit' ? updateOrg : addOrg;
      const params = {
        ...data,
        tenantId: this.userInfo.tenant_id,
      };
      if (Array.isArray(params.region)) {
        params.region = params.region.join(',');
      }
      submitFunction(params).then(
        res => {
          // 获取新增数据的相关字段
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          // 数据回调进行刷新
          this.orgDialog = false;
          this.onLoad(this.page);
          this.updateSideTree();
          done();
        },
        error => {
          window.console.log(error);
          done();
        }
      );
    },
    getDeptParam() {
      const userStr = localStorage.getItem('saber-userInfo') || '{}';
      const userInfo = JSON.parse(userStr);
      const params = {
        tenantId: userInfo.content?.tenant_id,
        deptId: userInfo.content?.dept_id,
      };
      return params;
    },
    handleSubmitUser(data, done) {
      const params = {
        parentId: data.id || '',
        ...data,
        tenantId: this.userInfo.tenant_id,
      }
      const submitFunction = this.operationType === 'edit' ? update : add;
      // const userInfo = this.getDeptParam();
      // const ownerItem = findInTreeIterative(this.deptTreeData, (node) => node.id === userInfo.deptId);
      // if (params.deptId != ownerItem.codes) {
      //   done()
      //   return this.$message.error(this.Lang.tips.cantSelectSuperiorDept);
      // }
      if (Array.isArray(params.deptId)) {
        params.deptId = params.deptId.join(',')
      }
      if (!params.areaCode) {
        params.areaCode = this.defaultAreaCode;
      }
      if (params.phone && !/^[0-9]{6,13}$/.test(params.phone)) {
        this.$message.error(this.Lang.tips.plzInput6to13Number+this.Lang.label.userinfoPhone)
        done();
        return;
      }
      submitFunction(params).then(
        () => {
          this.initFlag = false;
          this.$emit('refresh');
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.updateSideTree();
          this.onLoad(this.page, this.query)
          done();
          this.userDialog = false;
        },
        error => {
          window.console.log(error);
          done();
        }
      );
    },
    expandTreeToLevel(treeData, maxLevel = 3, currentLevel = 1) {
      // 用于递归展开前 3 级节点
      if (!Array.isArray(treeData)) return;

      treeData.forEach((node) => {
        // 如果当前层级小于等于最大层级，展开节点
        if (currentLevel <= maxLevel) {
          node.expanded = true;
        } else {
          node.expanded = false; // 超过最大层级的节点不展开
        }

        // 如果有子节点，递归处理
        if (node.children && node.children.length > 0) {
          this.expandTreeToLevel(node.children, maxLevel, currentLevel + 1);
        }
      });
    },
    updateSideTree() {
      const param = this.getDeptParam();
      getDeptTree(param).then(res => {
        const data = res.data.data;
        this.expandTreeToLevel(data, 3);
        this.treeData = data;
        this.$nextTick(() => {
          this.handleClickFirstNode();
        })
      });
    },
    handleClickFirstNode() {
      const tree = this.$refs.treeRef;
      if (tree) {
        tree.autoClickFirstNode()
      }
    },
    initData() {
      const tenantId = this.userInfo.tenant_id;
      const roleIds = this.userInfo.role_id;
      getRoleTree({tenantId, roleIds}).then(res => {
        const column = this.findObject(this.userFormOption.group, 'roleId');
        column.dicData = res.data.data;
      });
      getDictionary({code: 'EnvironmentMonitoring'}).then(res => {
        const data = res.data.data;
        this.selectOptions = data;
        this.typeName = data[0].i18nValue;
        this.typeKey = data[0].dictKey;
      });
      getCountryCodeList().then(res => {
        const data = res.data.data;
        data.forEach(item => {
          item.label = item.countryCode;
          item.value = item.countryCode;
        });
        const item = data.find(ele => ele.languageType == this.language)
        this.defaultAreaCode = item.countryCode;
        this.userForm.areaCode = item.countryCode;
        this.countryCodeList = data;
      });
    },
    submitRole() {
      const roleList = this.$refs.treeRole.getCheckedKeys().join(',');
      grant(this.ids, roleList).then(() => {
        this.roleBox = false;
        this.$message({
          type: 'success',
          message: this.Lang.tips.operationSuccess,
        });
        this.onLoad(this.page);
      });
    },
    rowSave(row, done, loading) {
      row.deptId = func.join(row.deptId);
      row.roleId = func.join(row.roleId);
      row.postId = func.join(row.postId);
      row.tenantId = this.userInfo.tenant_id;
      add(row).then(
        () => {
          this.initFlag = false;
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      row.deptId = func.join(row.deptId);
      row.roleId = func.join(row.roleId);
      row.postId = func.join(row.postId);
      update(row).then(
        () => {
          this.initFlag = false;
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
    },
    searchReset() {
      this.query = {};
      this.treeDeptId = '';
      this.onLoad(this.page);
    },
    handleSearch(val) {
      this.onLoad(this.page, {nameOrIds: val});
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.$refs.crud.toggleSelection();
        });
    },
    handleAudit() {
      this.auditMode = true;
      this.onLoad(this.page, this.query);
    },
    handleAuditPass() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      this.$confirm(this.Lang.tips.ifConfirmPassAudit, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return auditPass(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.$refs.crud.toggleSelection();
        });
    },
    handleAuditRefuse() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      this.$confirm(this.Lang.tips.ifConfirmRefuseAudit, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return auditRefuse(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.$refs.crud.toggleSelection();
        });
    },
    handleAuditBack() {
      this.auditMode = false;
      this.onLoad(this.page, this.query);
    },
    handleResetPassword(r) {
      if (r) {
        this.$refs.crud.toggleRowSelection(r, true); // 设置某一行选中
      }
      if (!this.selectionList.length) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      const row = this.selectionList[0];
      this.resetPasswordForm = {
        id: row.id,
        userId: row.id,
        name: row.name,
        tenantId: row.tenantId,
        password: '',
        account: row.account,
        email: row.email,
      };
      this.resetPasswordBox = true;
    },
    handleResetPasswordSubmit() {
      const form = this.resetPasswordForm;
      if (!validatePasswordSimple(form.password)) {
        this.$message.error(this.Lang.Text.userOrgPassLength);
        return;
      }
      resetPassword(this.ids, form.password).then((res) => {
        if (res.data.code === 200) {
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.resetPasswordBox = false;
          this.onLoad(this.page, this.query);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    handleReset() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      this.$confirm(this.Lang.tips.ifConfirmResetPassword, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return resetPassword(this.ids, this.password);
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.$refs.crud.toggleSelection();
        });
    },
    handleGrant() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      this.roleTreeObj = [];
      if (this.selectionList.length === 1) {
        this.roleTreeObj = this.selectionList[0].roleId.split(',');
      }
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getUser(this.form.id).then(res => {
          const data = res.data.data;
          data.sex = data.sex + '';
          this.form = data;
          if (this.form.hasOwnProperty('deptId')) {
            this.form.deptId = func.split(this.form.deptId);
          }
          if (this.form.hasOwnProperty('roleId')) {
            this.form.roleId = func.split(this.form.roleId);
          }
          if (this.form.hasOwnProperty('postId')) {
            this.form.postId = func.split(this.form.postId);
          }
        });
      }
      this.initFlag = true;
      done();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page, params = {}) {
      this.loading = true;
      const depIds = this.includeNodeType == '1' ? this.treeDeptIds : this.treeDeptId;
      getList(
        page.currentPage,
        page.pageSize,
        Object.assign(params, this.query),
        depIds
      ).then(res => {
        const data = res.data.data;
        this.page.total = data.total;
        const recordsList = data.records;
        recordsList.forEach((item, index) => {
          item.index = index + 1; // 添加前端字段给筛选
        })
        this.data = recordsList;
        this.loading = false;
        this.selectionClear();
      });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
